import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=c6ff060a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=c6ff060a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ff060a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6ff060a')) {
      api.createRecord('c6ff060a', component.options)
    } else {
      api.reload('c6ff060a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=c6ff060a&scoped=true&", function () {
      api.rerender('c6ff060a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oi3yHWFNmE2Z/JS/comp/CookieBox.vue"
export default component.exports